var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyBagIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 12.6316C55.74 12.6316 57.15 13.2632 58.26 14.4947C59.4 15.7895 60 17.2105 60 18.9474V53.6842C60 55.4211 59.4 56.8421 58.26 58.1368C57.15 59.3684 55.74 60 54 60H6C4.26 60 2.85 59.3684 1.74 58.1368C0.6 56.8421 0 55.4211 0 53.6842V18.9474C0 17.2105 0.6 15.7895 1.74 14.4947C2.85 13.2632 4.26 12.6316 6 12.6316H18V6.31579C18 4.48421 18.6 3 19.74 1.83158C20.85 0.631579 22.26 0 24 0H36C37.74 0 39.15 0.631579 40.26 1.83158C41.4 3 42 4.48421 42 6.31579V12.6316H54ZM6 18.9474V53.6842H54V18.9474H6ZM36 12.6316V6.31579H24V12.6316H36Z",
    fill: "#077CA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyBagIcon2);
export default __webpack_public_path__ + "static/media/MyBagIcon2.5a10252002338d8d6e9ca4a2d1a3d0fe.svg";
export { ForwardRef as ReactComponent };